<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">出场时间</span>
        <el-date-picker v-model="timevalue" size="small" type="datetimerange"
                        :picker-options="pickerOptions2" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>

      <div style="display: flex;justify-content: flex-end;">
        <input-search placeholder="车牌号" @search="searchKey" />
        <button-export style="margin-left: 10px;" :href="exportUrl" download="download.xls" :beforeDownload="beforeDownload" value="导出" v-if="permissionCodes.indexOf('004010001') !== -1"/>
      </div>
    </div>
    <div class="search-line">
      <div class="btn-box" style="display: flex;justify-content: center">
        <input-select selectTitle="是否异常" :selectKey="'normal'" :selectData="normalList" @search="search" style="margin-right: 10px"/>
        <input-select selectTitle="停车类型" :selectKey="'parkingType'" :selectData="parkingTypeList" @search="search" style="margin-right: 10px"/>
        <input-select selectTitle="优惠方式" :selectKey="'feeType'" :selectData="feeTypeList" @search="search" style="margin-right: 10px"/>
        <input-select selectTitle="缴费方式" :selectKey="'payChannel'" :selectData="payChannelList" @search="search" style="margin-right: 10px"/>
      </div>
      <div class="btn-box" style="display: flex;justify-content: center">
      </div>
    </div>
    <table-main :selection="false" :hasOperation="false" :tableHead="tableHead" @lookOverImg="lookOverImg" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />

    <el-dialog
      :visible.sync="dialogVisible"
      width="40%">
      <img :src="lookOverImgUrl" alt="" style="width: 90%;margin: 0 auto;">
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "parking-bill",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "停车账单"
        }
      ],
      addController: "controller-add",
      exportUrl: "",
      timevalue: [],
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      normalList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: true,
          label: "正常"
        },
        {
          key: false,
          label: "异常"
        }
      ],
      parkingTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "1",
          label: "包月车"
        },
        {
          key: "2",
          label: "临停车"
        },
        {
          key: "3",
          label: "无牌车"
        },
        {
          key: "4",
          label: "白名单车"
        },
        {
          key: "5",
          label: "黑名单车"
        }
      ],
      feeTypeList: [
        { key: "", label: "全部" },
        {key: "优惠券", label: "优惠券"},
        {key: "免费码", label: "免费码"},
      ],
      payChannelList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "1",
          label: "微信"
        },
        {
          key: "2",
          label: "支付宝"
        },
        {
          key: "3",
          label: "银行转账"
        },
        {
          key: "4",
          label: "现金"
        },
        {
          key: "6",
          label: "无感支付"
        },
        {
          key: "5",
          label: "其他"
        }
      ],
      tableHead: [
        {
          prop: "carNumber",
          label: "车牌号",
          width: "120px"
        },
        {
          prop: "carInDeviceName",
          isLookingImg: true,
          isLookingText: true,
          isLookingImgUrl: "carInSnapUrl",
          label: "进场位置",
          width: "180px"
        },
        {
          prop: "carInTime",
          label: "进场时间",
          width: "180px"
        },
        {
          prop: "carOutDeviceName",
          isLookingImg: true,
          isLookingText: true,
          isLookingImgUrl: "carOutSnapUrl",
          label: "出场位置",
          width: "180px"
        },
        {
          prop: "carOutTime",
          label: "出场时间",
          width: "180px"
        },
        {
          prop: "parkingDuration",
          label: "停车时长",
          width: "120px"
        },
        {
          prop: "parkingTypeText",
          label: "停车类型",
          width: "120px"
        },
        {
          prop: "parkTimeMoney",
          label: "应收(元)",
          width: "120px"
        },
        {
          prop: "payMoney",
          label: "实收(元)",
          width: "120px"
        },
        {
          prop: "discountMoney",
          label: "优惠金额(元)",
          width: "120px"
        },
        {
          prop: "feeType",
          label: "优惠方式",
          width: "120px"
        },
        {
          prop: "normalText",
          showColor: true,
          label: "账单状态",
          width: "120px"
        },
        {
          prop: "statusText",
          label: "缴费状态",
          width: "120px"
        },
        {
          prop: "payChannelText",
          label: "缴费方式",
          width: "120px"
        },
        {
          prop: "payTime",
          label: "缴费时间",
          width: "180px"
        },
        {
          prop: "memo",
          label: "备注",
          width: "180px"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        startTime: "",
        endTime: "",
        searchKey: "",
        feeType: "",
        payChannel: "",
        normal: "",
        parkingType: ""
      },
      lookOverImgUrl: "",
      dialogVisible: false
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    // this.exportUrl = `${api.exportCarAccessRecordPage}?yq-app-code=${bus.global.yqCode}&kj-type=gy`
    this.getCreateTime();
  },
  activated() {
    this.getCreateTime();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportParkingBill}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&startTime=${this.requestData.startTime}&endTime=${
        this.requestData.endTime
      }&feeType=${this.requestData.feeType}&payChannel=${
        this.requestData.payChannel
      }&normal=${this.requestData.normal}&parkingType=${
        this.requestData.parkingType
      }`;
    },
    getCreateTime() {
      this.timevalue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timevalue[0] = year + "-" + month + "-" + date + " " + "00:00:00";
      this.timevalue[1] = year + "-" + month + "-" + date + " " + "23:59:59";
      this.getPage();
    },
    // 获取进出记录
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0];
        this.requestData.endTime = this.timevalue[1];
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getParkingBillPage, reqData)
        .then(res => {
          let data = res.data.data.list;
          data.map(v => {
            if (v.status === "0") {
              v.statusText = "未缴费";
            } else if (v.status === "1") {
              v.statusText = "已缴费";
            }
            if (v.parkingType === "1") {
              v.parkingTypeText = "包月车";
            } else if (v.parkingType === "2") {
              v.parkingTypeText = "临停车";
            } else if (v.parkingType === "3") {
              v.parkingTypeText = "无牌车";
            } else if (v.parkingType === "4") {
              v.parkingTypeText = "白名单车";
            } else if (v.parkingType === "5") {
              v.parkingTypeText = "黑名单车";
            }
            if (v.normal) {
              v.normalText = "正常";
              v.fontColorToPeople = "#67C23A";
            } else {
              v.normalText = "异常";
              v.fontColorToPeople = "#F56C6C";
            }
            if (v.payChannel === "1") {
              v.payChannelText = "微信";
            } else if (v.payChannel === "2") {
              v.payChannelText = "支付宝";
            } else if (v.payChannel === "3") {
              v.payChannelText = "银行转账";
            } else if (v.payChannel === "4") {
              v.payChannelText = "现金";
            } else if (v.payChannel === "5") {
              v.payChannelText = "其他";
            } else if (v.payChannel === "6") {
              v.payChannelText = "无感支付";
            }
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取账单失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    lookOverImg(imgUrl) {
      this.lookOverImgUrl = imgUrl;
      this.dialogVisible = true;
    }
  },
  watch: {
    timevalue(val) {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingBill/ParkingBill.vue